import { WalmartLandingPage } from 'pages/loyalty/loyalty-partners/walmart';
import { useWalmartDisabledRedirect } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';

export default function WalmartPlusPage() {
  const disabledRedirect = useWalmartDisabledRedirect();
  if (disabledRedirect) {
    return disabledRedirect;
  }

  return <WalmartLandingPage />;
}
